import React, { Component } from 'react'

import { Loan } from './types'
import RuleForm from './ruleForm'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchLoan: Callback
  loan: Loan
  match: Match<ParamsID>
  updateLoan: Callback
}

export class UnderwritingRules extends Component<Props> {
  onSubmit = ({ ruleWaivers, adminNote }) => {
    const { loan, updateLoan } = this.props
    const rules = Object.keys(ruleWaivers)
    const waivers = rules.filter((rule) => ruleWaivers[rule])

    updateLoan(loan, { redecision: true, adminNote, ruleWaivers: waivers })
  }

  render() {
    const { loan } = (this.props || {}) as Partial<NonNullable<Props>>
    if (!loan) return null
    if (Object.keys(loan).length === 0) return null

    const initialValues = {
      ruleWaivers: (loan.rules || []).reduce((acc, { name, waive }) => {
        let current = {}
        current[name] = waive
        return { ...acc, ...current }
      }, {}),
    }

    return (
      <div>
        <div className="content">
          <RuleForm
            loan={loan}
            initialValues={initialValues}
            onSubmit={this.onSubmit}
          />
        </div>
      </div>
    )
  }
}
